import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import apiService from '../../../utlis/apiService';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Modal, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Download as DownloadIcon } from '@mui/icons-material';
import { apiUrl } from '../../../config';
import { TabContext, TabList, TabPanel } from '@mui/lab';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    width: '60vw',
    maxHeight: '90vh', 
    overflowY: 'scroll',
};

const ViewExams = ({ studentId }) => {
    const [examsModal, setExamsModal] = useState(false);
    const [examTab, setExamsTab] = useState('mock');
    const [exam, setExam] = useState([]);

    const fetchExamMarks = async () => {
        try {
            setExamsModal(true);
            const response = await apiService.get(`/student/get/exams?studentId=${studentId}`);
            setExam(response?.data);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div>
            <Button
                sx={{ float: 'right', marginRight: '10px' }}
                variant="contained"
                color="primary"
                onClick={fetchExamMarks}
            >
                Exams
            </Button>
            <Modal
                open={examsModal}
                onClose={() => setExamsModal(false)}
                aria-labelledby="modal-title"
            >
                <Box sx={{ ...style }}>
                    <TabContext value={examTab}>
						<Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '50px' }}>
							<TabList onChange={(e, value) => setExamsTab(value)} aria-label="exam tab">
								<Tab label="Mock" value="mock" />
								<Tab label="Main" value="main" />
							</TabList>
						</Box>
                        <TabPanel value="mock">
                            {exam.mock?.map((exam, index) => (
                                <Accordion defaultExpanded ={false} sx={{ marginBottom: 2 }} key={index}>
                                    <AccordionSummary
                                        expandIcon={<ArrowDownwardIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                        key={index}
                                    >
                                        <Typography>{exam.batch}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={2} alignItems="center" sx={{ marginTop: '1rem' }}>
                                            <Grid item xs={3}>
                                                <Typography>Date</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography>Name</Typography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Typography>Mark</Typography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Typography>Status</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography>Remark</Typography>
                                            </Grid>
                                        </Grid>
                                        {exam.exam?.map((mark, markIndex) => (
                                            <Grid container spacing={2} alignItems="center" sx={{ marginTop: '1rem' }} key={markIndex}>
                                                <Grid item xs={3}>
                                                    <Typography>{mark.date ? new Date(mark.date).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}</Typography>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography sx={{ textTransform: 'capitalize' }}>{mark.name}</Typography>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Typography>{mark.mark}</Typography>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Typography>{mark.status === true ? 'Present' : 'Absent'}</Typography>
                                                </Grid>
                                                <Grid item xs={4}>{mark.remark}</Grid>
                                            </Grid>
                                        ))}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </TabPanel>
                        <TabPanel value="main">
                            <Grid container spacing={2} alignItems="center" sx={{ marginTop: '1rem' }}>
                                <Grid item xs={3}>
                                    <Typography>Date</Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography>Name</Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography>Mark</Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography>Status</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography>Remark</Typography>
                                </Grid>
                            </Grid>
                            {exam.main?.map((mark, markIndex) => (
                                <Grid container spacing={2} alignItems="center" sx={{ marginTop: '1rem' }} key={markIndex}>
                                    <Grid item xs={3}>
                                        <Typography>{mark.date ? new Date(mark.date).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography sx={{ textTransform: 'capitalize' }}>{mark.name}</Typography>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Typography>{mark.mark}</Typography>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Typography>{mark.status === true ? 'Present' : 'Absent'}</Typography>
                                    </Grid>
                                    <Grid item xs={4}>{mark.remark}</Grid>
                                </Grid>
                            ))}
                        </TabPanel>
                    </TabContext>
                    <Button onClick={() => { setExamsModal(false); setExam([])}} sx={{ marginTop: 2}} variant="outlined">Close</Button>
                </Box> 
            </Modal>
        </div>
    );
};

export default ViewExams;
